import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=ba10a560"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=ba10a560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports